import React, { useCallback } from "react";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { SmartlistType } from "../../api/MediaAPI.types";
import CreateButton from "../common/CreateButton";
import GenericSmartlistList from "../common/smartlist/GenericSmartlistList";
import { PROJECTS_ROUTE } from "../routes/routes";

import type { JSX } from "react";

function SmartlistSeriesList(): JSX.Element {
  const { t } = useTranslation("editor-series");
  const getDeleteBody = useCallback(
    (label: string): string => t("deleteBody", { smartlist: label }),
    [t],
  );
  const { projectSlug } = useParams<{ projectSlug: string }>();

  const breadcrumbs = [
    {
      name: t("editor-menu:publishing-management"),
      url: "/series",
    },
    {
      name: t("sectionTitle"),
    },
  ];

  const createButton = (
    <CreateButton
      href={`${PROJECTS_ROUTE}/${projectSlug}/series/new/`}
      label={t("createSerie")}
    />
  );

  return (
    <GenericSmartlistList
      breadcrumbs={breadcrumbs}
      createButton={createButton}
      deleteCompleteText={t("deleteComplete")}
      deleteTitle={t("deleteTitle")}
      editUrlPrefix="series"
      getDeleteBody={getDeleteBody}
      smartlistTypes={SmartlistType.SERIES}
      tableTitle={t("sectionTitle")}
    />
  );
}

export default SmartlistSeriesList;
